export default __webpack_public_path__ + "files/code_themes/1c007fd17dfb3face766fcbb631167b8.css";